import AvatarView from "@/components/base/AvatarView"
import RowInfo from "@/components/data/RowInfo"
import { FieldEdit } from "@/components/form/fields/FieldEdit"
import FormField from "@/components/form/FormField"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Fields } from "@/lib/fields"
import { store } from "@/stores/stores"
import { Container, SimpleGrid, Stack, TextInput, Title } from "@mantine/core"
import { useSnapshot } from "valtio"
import { z } from "zod"

const zChangePassword = z.object({
  currentPassword: z.string().min(8, "A senha deve ter pelo menos 8 caracteres"),
  newPassword: z.string().min(8, "A senha deve ter pelo menos 8 caracteres"),
})

function Account() {
  const snap = useSnapshot(store)

  return (
    <Container size="md" className="p-4 pt-0">
      <div className="flex flex-col gap-10">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-4">
            <FieldEdit
              initialValue={snap.session.user?.image}
              onSubmit={(value) => snap.session.actions.updateAccount({ image: value })}
              mode={"modal"}
              type={Fields.enum.Avatar}
              title="Edit avatar"
              editableProps={{
                extra: {
                  name: snap.session.user?.name,
                },
              }}
            >
              <AvatarView
                src={snap.session.user?.image || ""}
                name={snap.session.user?.name}
                className="size-15"
                floatingIcon={IconMagePenFill}
              />
            </FieldEdit>
            <div>
              <h3 className="text-left text-sm font-medium">{snap.session.user?.name}</h3>
              <span className="text-secondary">{snap.session.user?.email}</span>
              {/* <Badge color="dark" mt={-3}>
              Owner
            </Badge> */}
            </div>
          </div>
          <FieldEdit
            title="Change name"
            initialValue={snap.session.user?.name}
            onSubmit={(value) => snap.session.actions.updateAccount({ name: value })}
          >
            <Button variant="outline" className="rounded-full">
              Change name
            </Button>
          </FieldEdit>
        </div>
        {/* <RowInfo
          label="Name"
          value={snap.session.user?.name}
          editTitle="Edit name"
          editLabel="Change name"
          editInitialValue={snap.session.user?.name}
          editOnSubmit={(value) => snap.session.actions.updateAccount({ name: value })}
        /> */}
        {/* <RowInfo label="Email" value={snap.session.user?.email}></RowInfo> */}
        <RowInfo label="Password" value="Set a sign in password">
          <FieldEdit
            zSchema={zChangePassword}
            getEditable={(dto) => {
              return (
                <div className="flex flex-col gap-6">
                  <FormField form={dto.form} name="value.currentPassword" label="Current password">
                    <Input placeholder="Type current password" autoFocus size="lg" type="password" />
                  </FormField>
                  <FormField form={dto.form} name="value.newPassword" label="New password">
                    <Input placeholder="Type new password" size="lg" type="password" />
                  </FormField>
                </div>
              )
            }}
            title="Change password"
            initialValue={{
              currentPassword: "",
              newPassword: "",
            }}
            onSubmit={(values) => snap.session.actions.changePassword(values)}
          >
            <Button variant="outline" className="rounded-full">
              Change password
            </Button>
          </FieldEdit>
        </RowInfo>

        {/* <SimpleGrid cols={2} spacing="xl" verticalSpacing="lg">

          <FieldEdit
            title="Edit name"
            initialValue={snap.session.user?.name}
            onSubmit={(value) => snap.session.actions.updateAccount({ name: value })}
          >
            <SelectableTextInput value={snap.session.user?.name} label="Name" />
          </FieldEdit>
          <TextInput
            value={snap.session.user?.email}
            label="Email"
            variant="filled"
            size="md"
            withAsterisk={false}
            disabled
            className={`[&_input]:text-fg [&_input]:opacity-100 hover:[&_input]:text-[var(--input-disabled-color)]`}
          />
          <FieldEdit
            getEditable={(dto) => {
              const passwordInputProps = { ...dto.form?.getInputProps("value.password"), "data-autofocus": true }
              const confirmPasswordInputProps = { ...dto.form?.getInputProps("value.confirmPassword"), "data-autofocus": true }
              return (
                <Stack>
                  <TextInput
                    label="New password"
                    placeholder="Type new password"
                    variant="filled"
                    size="md"
                    autoFocus
                    {...passwordInputProps}
                  />
                  <TextInput
                    label="Repeat new password"
                    placeholder="Repeat new password"
                    variant="filled"
                    size="md"
                    autoFocus
                    {...confirmPasswordInputProps}
                  />
                </Stack>
              )
            }}
            title="Change password"
            initialValue={{}}
            onSubmit={(values) => snap.session.actions.changePassword(values)}
          >
            <ButtonBlock leftSection={<IconHugeiconsSquareLockPassword />}>Change password</ButtonBlock>
          </FieldEdit>
        </SimpleGrid> */}
      </div>
    </Container>
  )
}

export default Account
